// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"e377d113","686":"86f9495f","741":"aa6287dd"}[chunkId] + ".chunk.js";
};